'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { ClientStepOption } from '@susu/headless-commerce/features/configurator/components/StepOption/ClientStepOption'
import styles from '@susu/headless-commerce/features/configurator/components/StepOptions/StepOptions.module.scss'
import { configuratorSignal } from '@susu/headless-commerce/features/configurator/signals/configurator'
import { isNotUndefined } from '@susu/undefined'
import classNames from 'classnames'
import type { CSSProperties } from 'react'

export const ClientStepOptions = () => {
  useSignals()

  const configurator = configuratorSignal.value

  return (
    <div
      className={styles.options}
      style={
        {
          '--options-count': `${configurator.orderedOptions.value.length}`,
        } as CSSProperties
      }
    >
      <div
        className={classNames(styles['options-list'], {
          [styles['options-list__half']]:
            configurator.orderedOptions.value.length === 2,
        })}
      >
        {configurator.orderedOptions.value.map((option) => {
          const id = option.product.value.id.value ?? undefined
          const count = configurator.orderedOptions.value.length
          const isOutOfStock =
            isNotUndefined(id) &&
            option.product.value.availability.value.isAvailable.value === false
          const name = option.product.value.name.value ?? ''
          const key = `${id ?? name}-${name}`
          const thumbnailImage = option.thumbnailImage ?? undefined
          const recommendedIndication =
            configurator.selection.value.isOptionRecommended(option)

          return (
            <ClientStepOption
              count={count}
              id={id}
              key={key}
              name={name}
              option={option}
              isOutOfStock={isOutOfStock}
              recommendedIndication={recommendedIndication}
              thumbnailImage={thumbnailImage.value}
            />
          )
        })}
      </div>
    </div>
  )
}
